import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, Download, Loader2, ArrowLeft, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CheckoutSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ loading: true, data: null, error: null });

  useEffect(() => {
    if (!sessionId) {
      setStatus({ loading: false, data: null, error: "Keine Session-ID gefunden." });
      return;
    }
    let attempts = 0;
    let cancelled = false;

    const poll = async () => {
      if (cancelled) return;
      try {
        const res = await axios.get(`${API}/checkout/status/${sessionId}`);
        if (res.data.payment_status === "paid") {
          setStatus({ loading: false, data: res.data, error: null });
          return;
        }
        if (res.data.status === "expired") {
          setStatus({ loading: false, data: null, error: "Die Zahlungssitzung ist abgelaufen." });
          return;
        }
        if (attempts++ < 8) setTimeout(poll, 2000);
        else setStatus({ loading: false, data: null, error: "Zahlungsbestätigung dauert länger als erwartet. Prüfe dein Postfach in wenigen Minuten." });
      } catch (e) {
        setStatus({ loading: false, data: null, error: "Status konnte nicht geprüft werden." });
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div data-testid="checkout-success" className="min-h-screen bg-[#F4F1ED] text-[#2C332E] flex items-center justify-center px-6 py-16">
      <div className="max-w-lg w-full">
        <Link to="/" data-testid="success-back" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.24em] text-[#5C6660] hover:text-[#2C332E] mb-10">
          <ArrowLeft size={14} /> Zur Startseite
        </Link>

        {status.loading && (
          <div className="text-center space-y-4">
            <Loader2 className="animate-spin mx-auto text-[#738678]" size={40} />
            <p className="text-[#5C6660]">Zahlung wird geprüft…</p>
          </div>
        )}

        {status.error && !status.loading && (
          <div data-testid="success-error" className="border border-[#D5CECA] bg-white p-8">
            <AlertCircle className="text-[#B05D3E]" size={32} />
            <h1 className="mt-4 text-2xl entry-display">Hmm — kurz Geduld</h1>
            <p className="mt-3 text-[#5C6660]">{status.error}</p>
          </div>
        )}

        {status.data && !status.loading && (
          <div className="border border-[#D5CECA] bg-white p-10">
            <CheckCircle2 size={44} className="text-[#738678]" />
            <h1 className="mt-5 text-3xl md:text-4xl entry-display leading-tight">Danke. Deine Zahlung ist bestätigt.</h1>
            <p className="mt-4 text-[#5C6660]">Wir haben dir den Download-Link auch per E-Mail an <b>{status.data.customer_email}</b> geschickt.</p>
            <div className="mt-6 border border-[#D5CECA] bg-[#F4F1ED] p-5">
              <p className="eyebrow text-[#5C6660]">Dein Produkt</p>
              <p className="mt-2 text-xl text-[#2C332E]" style={{ fontFamily: "Cormorant Garamond, serif" }}>{status.data.product_title}</p>
            </div>
            <a
              data-testid="success-download"
              href={`${API}/download/${status.data.download_token}`}
              className="mt-7 btn-sage w-full justify-center"
            >
              <Download size={16} /> Jetzt herunterladen
            </a>
            <p className="mt-4 text-xs text-[#5C6660]">Link 72 Std. gültig, bis zu 5 Downloads. Speicher die Datei lokal nach dem Download.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckoutSuccess;
